import type { GridAudioSoundPlayer } from "../GridLayer";
import type { ColumnLanding, GridLandReaction } from "./GridLandReaction";

/**
 * Per-symbol land sounds from the catalog (`landSoundKey`): deduped per column, staggered a few
 * milliseconds apart. Sound ids owned by another reaction (a pitched stinger) are skipped here.
 */
export class SymbolLandSounds implements GridLandReaction {
  private readonly audio: GridAudioSoundPlayer;
  private readonly ownedElsewhere: ReadonlySet<string>;
  private readonly staggerSeconds: number;

  public constructor(input: { audio: GridAudioSoundPlayer; ownedElsewhere?: ReadonlySet<string>; staggerSeconds?: number }) {
    this.audio = input.audio;
    this.ownedElsewhere = input.ownedElsewhere ?? new Set();
    this.staggerSeconds = input.staggerSeconds ?? 0.03;
  }

  public onColumnLanded(landing: ColumnLanding): void {
    const soundIds = Array.from(new Set(landSoundIds(landing).filter((id) => !this.ownedElsewhere.has(id))));
    for (let i = 0; i < soundIds.length; i++) {
      const delaySeconds = i * this.staggerSeconds;
      if (delaySeconds <= 0 || !this.audio.playSoundIdDelayed) this.audio.playSoundId(soundIds[i]);
      else this.audio.playSoundIdDelayed(soundIds[i], delaySeconds);
    }
  }
}

/** The land-sound ids present in the column, in row order (one entry per sounded cell). */
export function landSoundIds(landing: ColumnLanding): string[] {
  const ids = landing.views.length > 0 ? landing.views.map((view) => view.getCurrentLandSoundKey() ?? "") : landing.definitions.map((definition) => definition?.landSoundKey ?? "");
  return ids.map((id) => id.trim()).filter((id) => id.length > 0);
}
